import { DataScope, getDataClass } from 'scrivito'

import { DocumentRelationType } from './types'
import { DataClassName } from '@/Data/const'

export const getFixedFolderAttributes = () => {
  const base = ['title']

  return base
}

export const getDocumentScope = (
  dataClassname?: DocumentRelationType,
): DataScope | null => {
  if (!dataClassname) {
    return null
  }
  const dataClass = getDataClass(dataClassname)
  if (!dataClass) {
    return null
  }
  return dataClass.all()
}

export const getRelationFilter = (relationTo: DocumentRelationType) => {
  switch (relationTo) {
    case DataClassName.ACTIVITY_DOCUMENT_RELATION:
      return 'activity'
    case DataClassName.DOCUMENT_PROJECT_RELATION:
      return 'project'
    case DataClassName.CONTACT_DOCUMENT_RELATION:
      return 'contact'
    default:
      return ''
  }
}

export const downloadFile = (url?: string, filename?: string) => {
  if (!url) return

  const link = window.document.createElement('a')
  link.href = url
  link.download = filename || ''
  link.target = '_blank'
  link.rel = 'noreferrer'

  window.document.body.appendChild(link)
  link.click()
  window.document.body.removeChild(link)
}
